/**
 * reflect the field name of the object
 * import reflectName from "./reflectName"
 *
 * let x: T = {}
 * let name = reflectName(()=> (x.FieldName = null, x));
 * assert.(name === "FieldName");
 */

export default function reflectName<T>(setName: () => T) : string {
    let x: any = setName();
    const result = _.first(_.keys(x));
    delete x[result];
    return result;
}

/**
 * reflects the field name of the object
 * 
 * import { reflectNameOf } form "./NameReflector";
 * let name = reflectNameOf<Foo>(x => x.Bar = null);
 * assert.(name == "Bar");
 */
export function reflectNameOf<T>(callback: (t:T) => any): string {
    let x = {} as T;
    callback(x);
    return _.first(_.keys(x));
}



// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Utils/NameReflector.ts